import React from "react";
import { QuoteIcon } from "lucide-react";
import { Stars } from "./Stars";
import { testimonials } from "../data/salesContent";
export function Testimonials() {
  return <section aria-labelledby="testimonios" className="w-full bg-cream py-16 lg:py-20" data-id="element-152" data-mp="3fznszj43v70b">
      <div className="mx-auto max-w-6xl px-5" data-id="element-153" data-mp="3fxb2ghka7obn">
        <h2 id="testimonios" className="text-center font-display text-3xl font-black text-ink sm:text-4xl" data-id="element-154" data-mp="3azjcvu740eam">
          Lo que dicen quienes ya venden
        </h2>
        <div className="mt-10 grid gap-5 md:grid-cols-3" data-id="element-155" data-mp="31zwb37agx6h1">
          {testimonials.map(t => <figure key={t.initials} className="flex flex-col rounded-2xl border border-cream-deep bg-white p-6" data-id="element-156" data-mp="2x0tgkgs46inb">
              <QuoteIcon className="h-7 w-7 text-gold" aria-hidden="true" data-id="element-157" data-mp="2s28dm9lh9kv6" />
              <blockquote className="mt-4 flex-1 text-lg font-medium leading-snug text-ink" data-id="element-158" data-mp="2s430htgb7n1w">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 flex items-center gap-3 border-t border-cream-deep pt-4" data-id="element-159" data-mp="qbeu5b8dcjhw">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-ink font-display text-sm font-bold text-gold" data-id="element-160" data-mp="h4wyecfigumy">
                  {t.initials}
                </span>
                <div data-id="element-161" data-mp="78tvh4cu4ryy">
                  <p className="font-display text-sm font-bold text-ink" data-id="element-162" data-mp="79bo7r0ago24">
                    {t.initials} — {t.city}
                  </p>
                  <Stars className="h-3.5 w-3.5" data-id="element-163" data-mp="zwfv61ixzcgj" />
                </div>
              </figcaption>
            </figure>)}
        </div>
      </div>
    </section>;
}